module.exports = __webpack_public_path__ + "static/media/sweet_4.fd48d060.png";